import { Entity } from "../../../shared/domain/Entity";

export class UserPlatformDto extends Entity {
  constructor(data: any = undefined) {
    super(data);

    if (data !== undefined && data !== null) {
      this.id = data.id;
      this.firstname = data.firstname;
      this.lastname = data.lastname;
      this.email = data.email;
      this.role = data.role;
      this.state = data.state;
      this.allowDoubleFactor = data.allowDoubleFactor;
      this.allowSendReports = data.allowSendReports;
    }
  }

  public id: number | null | undefined;
  public firstname: string = '';
  public lastname: string = '';
  public email: string = '';
  public role: string = '';
  public state: number = 1;
  public allowDoubleFactor: boolean = true;
  public allowSendReports: boolean = true;
}
